import React, { Component } from "react";
import { connect } from "react-redux";
import Reference from "../components/Reference";
import { searchCompanies } from "../../../../actions/company.actions";
import {
  getQuestions,
  checkState,
  getReference,
  declineReference,
  createReference
} from "../../../../actions/workReferences.actions";
import { getReferenceRelationships } from "../../../../actions/dropdowns.actions";
import Confirmation from "../components/Confirmation";
import qs from "qs";

class ReferenceContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnDecline = this.handleOnDecline.bind(this);

    this.state = {
      referenceId: qs.parse(props.location.search.slice(1)).id
    };
  }

  componentWillMount() {
    if (this.state.referenceId) this.props.checkState(this.state.referenceId);
  }

  componentDidMount() {
    this.props.getQuestions();
    this.props.getReferenceRelationships();
    if (this.state.referenceId) this.props.getReference(this.state.referenceId);
  }

  handleSubmit(data) {
    // reference_id
    data.reference_id = this.state.referenceId;

    // Skills
    if (data.skills && data.skills.length > 0) {
      data.skills = data.skills
        .map((s, index) => ({ id: index, value: s }))
        .filter(s => s.value)
        .map(s => ({ id: s.id }));
    }

    // Answers
    if (data.answers && data.answers.length > 0) {
      data.answers = data.answers
        .map((a, index) => ({ id: index, value: a }))
        .filter(s => s.value)
        .map(s => ({ question_id: s.id, value: s.value }));
    }

    // Submit
    this.props.createReference(data);
  }

  handleOnDecline() {
    this.props.declineReference(this.state.referenceId);
  }

  alreadyFilled() {
    if (
      this.props.referenceState &&
      this.props.referenceState.length > 0 &&
      (this.props.referenceState[0].filled ||
        this.props.referenceState[0].declined)
    ) {
      return true;
    }
    return false;
  }

  render() {
    if (this.props.isReferenceStateLoading || !this.state.referenceId)
      return null;

    if (this.alreadyFilled()) {
      return <Confirmation reference={this.props.reference} />;
    }
    return (
      <Reference
        onSubmit={this.handleSubmit}
        companies={this.props.companies}
        isLoading={this.props.isLoading}
        onSearchCompanies={this.props.searchCompanies}
        questions={this.props.questions}
        referenceRelationships={this.props.referenceRelationships}
        referenceId={this.state.referenceId}
        reference={this.props.reference}
        onDecline={this.handleOnDecline}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    companies: state.company.companies.data,
    isLoading: state.company.isLoading,
    questions: state.workReferences.questions.data,
    referenceRelationships: state.dropdowns.referenceRelationships.data,
    referenceState: state.workReferences.referenceState.data,
    reference: state.workReferences.reference.data,
    isReferenceStateLoading: state.workReferences.isReferenceStateLoading
  };
};

const mapDispatchToProps = dispatch => ({
  searchCompanies: query => dispatch(searchCompanies(query)),
  getQuestions: () => dispatch(getQuestions()),
  getReferenceRelationships: () => dispatch(getReferenceRelationships()),
  checkState: refId => dispatch(checkState(refId)),
  getReference: refId => dispatch(getReference(refId)),
  declineReference: refId => dispatch(declineReference(refId)),
  createReference: data => dispatch(createReference(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferenceContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/reference/containers/ReferenceContainer.js